import { CreatorCollectionPlaybackMeta } from 'types/creator';

export const getCollectionPlaceholder = (
    playbackMeta?: CreatorCollectionPlaybackMeta,
) => {
    return playbackMeta
        ? `[${playbackMeta.bpm}]-[${playbackMeta.keyRoot}${playbackMeta.keyQuality}]-`
        : undefined;
};
